import React from 'react';
import PropTypes from 'prop-types';
import { StyledWrapper, StyledH5, StyledFlexRow, StyledImageWrapper, StyledDetailsWrapper } from './ProductBundleSliderStyles';

import ProductDetails from '../ProductDetails/ProductDetails';

import Slider from 'react-slick';

var ProductBundleSlider = function ProductBundleSlider(props) {
  return React.createElement(
    StyledWrapper,
    null,
    React.createElement(
      Slider,
      null,
      props.bundleProducts.map(function (product) {
        return React.createElement(
          'div',
          { key: product.product.title },
          React.createElement(
            StyledH5,
            null,
            product.product.title
          ),
          React.createElement(
            StyledFlexRow,
            null,
            React.createElement(
              StyledImageWrapper,
              null,
              React.createElement('img', {
                src: product.product.images.edges[0].node.productImg,
                alt: product.product.title
              })
            ),
            React.createElement(
              StyledDetailsWrapper,
              null,
              React.createElement(ProductDetails, {
                whyWeLove: product.product.whyWeLove,
                care: product.product.care,
                careLongText: product.product.careLongText,
                expertTips: product.product.expertTips,
                material: product.selectedVariant.material,
                dimension: product.selectedVariant.dimension,
                descriptionHtml: product.product.descriptionHtml,
                bundle: true
              })
            )
          )
        );
      })
    )
  );
};

ProductBundleSlider.propTypes = {
  selected: PropTypes.object,
  bundleProducts: PropTypes.array
};

export default ProductBundleSlider;